export default __webpack_public_path__ + "static/media/smallerearth.a340ddf6.jpg";